import BaseClient from './BaseClient';

class AdminOrgUnitsClient extends BaseClient {
    listOrgUnits(params, config) {
        const url = `/api/admin/org-units`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    createOrgUnit(teamId, data) {
        const url = `/api/admin/teams/${teamId}/org-units`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    favoriteOrgUnit(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteFavoriteOrgUnit(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getHubspotCompanyId(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateHubspotCompanyId(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }

    enableBilling(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-enable`;
        return this.makeCoreApiRequest(url, 'post');
    }

    updateBillingOptions(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-options`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    unsetBillingInformation(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-information`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    unsetBillingEmail(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/billing-email`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getPricing(teamId, orgUnitId) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/pricing`;
        return this.makeCoreApiRequest(url, 'get');
    }

    setPricing(teamId, orgUnitId, data) {
        const url = `/api/admin/teams/${teamId}/org-units/${orgUnitId}/pricing`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}

export default new AdminOrgUnitsClient();
